export interface IframeExtractionResult {
  textContent: string;
  iframes: string[];
  hasIframe: boolean;
}

export function separateIframeFromText(content: string): IframeExtractionResult {
  const iframeRegex = /<iframe[^>]*(?:\/>|>[\s\S]*?<\/iframe>)/gi;
  const iframes = content.match(iframeRegex) || [];
  const textContent = content.replace(iframeRegex, '').trim();
  
  return {
    textContent,
    iframes,
    hasIframe: iframes.length > 0
  };
}

export function extractFirstIframe(content: string): string | null {
  const match = content.match(/<iframe[\s\S]*?<\/iframe>/i);
  return match ? match[0] : null;
}

export function getIframeUrl(iframeContent: string): string | null {
  const match = iframeContent.match(/src="([^"]+)"/);
  return match ? match[1] : null;
}
export interface WidgetType {
  isChart: boolean;
  isCard: boolean;
  isTable: boolean;
  isGrid: boolean;
}

export function detectWidgetType(iframeContent: string): WidgetType {
  const lowerContent = iframeContent.toLowerCase();
  return {
    isChart: lowerContent.includes('chart') || lowerContent.includes('graph'),
    isCard: lowerContent.includes('card'),
    isTable: lowerContent.includes('table'),
    isGrid: lowerContent.includes('grid'),
  };
}

export function setIframeViewMode(
  iframeContent: string, 
  viewMode: 'half' | 'full'
): string {
  if (!iframeContent) return iframeContent;
  
  return iframeContent.replace(
    /(<iframe[^>]*src=")([^"]+)("[^>]*>)/gi,
    (match, prefix, url, suffix) => {
      const separator = url.includes('?') ? '&' : '?';
      const cleanUrl = url.replace(/[?&]viewMode=[^&]+/, '');
      return `${prefix}${cleanUrl}${separator}viewMode=${viewMode}${suffix}`;
    }
  );
}

export function recolorIframe(
  iframeContent: string,
  fromColor: string,
  toColor: string
): string {
  const regex = new RegExp(fromColor, 'gi');
  return iframeContent.replace(regex, toColor);
}

export function addPostMessageSupport(iframeContent: string): string {
  if (!iframeContent) return iframeContent;

  return iframeContent.replace(
    /(<iframe[^>]*)(>)/gi,
    (match, prefix, suffix) => {
      if (prefix.includes('sandbox')) {
        prefix = prefix.replace(
          /sandbox="[^"]*"/,
          'sandbox="allow-scripts allow-same-origin allow-forms"'
        );
      } else {
        prefix += ' sandbox="allow-scripts allow-same-origin allow-forms"';
      }
      return prefix + suffix;
    }
  );
}

